import React from 'react';
import { useAppSelector } from '../../redux/hooks';

const About = () => {
	const version = import.meta.env.REACT_APP_VERSION;
	const currentOrganization = useAppSelector(state => state.appState.currentOrganization);

	return (
		<div className="container" style={{marginTop:0}}>
			<div className="row">
				<div className="col-12">
					<div className="card">
						<div className="card-body align-items-center">							
							<div data-testid="AboutOrganizationName"><strong>{currentOrganization?.name || ''}</strong></div>
							<div data-testid="AboutVersion">{version || ''}</div>
							<div data-testid="AboutCopyright">Copyright &copy; 2025, Gridline</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default About;

